import { Tokens } from '@/assets/tokens'
import { HealthStatus } from '@/pages'
import styled, { css } from 'styled-components'

export const Container = styled.div`
  width: 100%;
  min-height: 84px;
  height: fit-content;
  border-radius: 1.2rem;
  padding: 1.4rem 2rem;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;

  background-color: ${Tokens.ColorWhite};
`

export const ContainerName = styled.div`
  width: 20rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
`

export const LinksContainer = styled.div`
  width: 16rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const HealthCheckStatus = styled.div<{ $status: HealthStatus }>`
  width: 1rem;
  height: 1rem;
  border-radius: 1rem;

  justify-self: flex-start;

  ${({ $status }) => {
    switch ($status) {
      case 'success':
        return css`
          border: 2px solid ${Tokens.ColorUIPrimaryDim};
          box-shadow: 0 0 10px ${Tokens.ColorUIPrimaryDim};
          background-color: ${Tokens.ColorUIPrimary};
        `
      case 'warning':
        return css`
          border: 2px solid ${Tokens.ColorUIWarnDim};
          box-shadow: 0 0 10px ${Tokens.ColorUIWarnDim};
          background-color: ${Tokens.ColorUIWarn};
        `
      case 'error':
        return css`
          border: 2px solid ${Tokens.ColorUIDangerDim};
          box-shadow: 0 0 10px ${Tokens.ColorUIDangerDim};
          background-color: ${Tokens.ColorUIDanger};
        `
    }
  }}
`
